import { Box, FlexColumn, FlexRowCenter, MessageDialog, OverflowText } from "designSystem/index";
import { black } from "designSystem/styles/color";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { useCustomViewDialogStore } from "../CustomViewDialogStore";
import CompositeViewItem from "./CompositeViewItem";

const CompositeTab: FunctionComponent = observer((props) => {
	const { STANDARD_PADDING, compositeViewStore } = useCustomViewDialogStore();
	const {
		permissionErrorRes,
		permissionViolation,
		resetViolation,
		views,
	} = compositeViewStore;

	return (
		<>
			<Box padding={STANDARD_PADDING}>
				<OverflowText
					color={black[100]}
					lineHeight={16}
					res="CustomViewCompositeDescription"
				/>
				<FlexRowCenter py={3}>
					<FlexColumn width={558}>
						{
							views.map((view, index) => (
								<CompositeViewItem
									key={index}
									view={view}
								/>
							))}
					</FlexColumn>
				</FlexRowCenter>
			</Box>
			{permissionViolation && (
				<MessageDialog
					category="warn"
					messageRes="CustomViewCompositePermissionError"
					messageResParams={permissionErrorRes}
					onClose={resetViolation}
					open
					titleRes="CustomViewCompositePermissionErrorTitle"
				/>
			)}
		</>
	);
});

export default CompositeTab;